module.exports = __webpack_public_path__ + "static/media/soggiorno_classico.b62ca543.jpg";